/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sanction_Lifted_DateInputs */



/**
* | output |
* | --- |
* | "Lifted: {date}" |
*
* @param {Sanction_Lifted_DateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_lifted_date = /** @type {((inputs: Sanction_Lifted_DateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Lifted_DateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Levée le : ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Levantada: ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Removida: ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Revocata: ${i?.date}`)
	return /** @type {LocalizedString} */ (`Lifted: ${i?.date}`)
});